// removed by extract-text-webpack-plugin
module.exports = {"homePage":"src-pages----index-module---homePage---ASJ9f","bottom":"src-pages----index-module---bottom---bemED","link":"src-pages----index-module---link---3a3Th"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.css
// module id = 296
// module chunks = 35783957827783